import { Field, ErrorMessage } from 'formik'
import React from 'react'

import FormFieldErrorMessage from './form-field-error-message'
import Tooltip from '../tooltip/tooltip'

const TextareaFormikField: React.FC<any> = ({
  touched = {},
  errors = {},
  label = '',
  helpText = '',
  newLineForHelpText = true,
  placeholder = '',
  name = '',
  toolTipMessage = '',
  toolTipTitle = '',
  readOnly = false,
}) => (
  <>
    <label
      className={`${
        readOnly && 'border-bottom'
      }  flex flex-col justify-between py-3 sm:items-start label`}
    >
      {label ? (
        <span className={`${
          readOnly ? 'text-black' : 'font-bold'
        } text-base`} >
          {label} {newLineForHelpText ? <br /> : null}{' '}
          {helpText ? <span className="font-normal text-xs">{helpText}</span> : null}
        </span>
      ) : null}
      <div className="w-full">
        <div className="flex justify-between items-center">
          <Field
            as="textarea"
            name={name}
            placeholder={placeholder}
            className={`w-11/12 form-textarea mt-1 text-grey-700 ${
              errors[name] && touched[name] ? 'border border-warn-600' : 'border border-grey-500'
            }`}
            readOnly={readOnly}
          />
          {toolTipMessage && toolTipTitle ? (
            <Tooltip message={toolTipMessage} title={toolTipTitle} />
          ) : null}
        </div>
      </div>
    </label>
    <div className="min-h-6">
      <ErrorMessage component={FormFieldErrorMessage} name={name} />
    </div>
  </>
)

export default TextareaFormikField
